// src/pages/user/ViewUser.jsx
import  { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.js';
import '../users/ViewUser.css';

function ViewUser() {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = sessionStorage.getItem('jwtToken');
  const { userInfo } = useAuth();
  const loggedRole = userInfo?.role || '';
  const is_single_user = userInfo?.is_single_user;

  const [userData, setUserData] = useState(null);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);

  axios.defaults.withCredentials = true;

  useEffect(() => {
    if (loggedRole === 'super_admin' && !is_single_user) {
      axios
        .get(`${process.env.REACT_APP_BACKEND_URL}/location/allLocations`, {
          headers: {
            Authorization: `Bearer ${token}`          },
        })
        .then((res) => {
          const locs = res.data.data || res.data;
          setLocations(Array.isArray(locs) ? locs : []);
        })
        .catch((err) => console.error('Error fetching locations', err));
    }
  }, [loggedRole, is_single_user, token]);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/user/get/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`            },
          }
        );
        setUserData(res.data.data);
      } catch (err) {
        console.error('Error fetching user data:', err);
        alert('Fout bij laden van gebruiker.');
        navigate('/users');
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [id, token, navigate]);

  const handleBack = () => {
    navigate('/users');
  };

  const getLocationNames = (idsArray) => {
    if (!Array.isArray(idsArray) || idsArray.length === 0) return '—';

    if (loggedRole === 'super_admin' && !is_single_user) {
      const names = idsArray
        .map((locationId) => {
          const loc = locations.find((l) => l.location_id === locationId);
          return loc ? loc.location_name : null;
        })
        .filter(Boolean);

      return names.length > 0 ? names.join(', ') : '—';
    }

    return idsArray.join(', ');
  };

  if (loading) return <p>Loading...</p>;
  if (!userData) return <p>Gebruiker niet gevonden.</p>;

  return (
    <div className="bg-white p-4 view-user">
      <h2 className="text-center">Gebruiker Bekijken</h2>
      <hr className="separator" />

      <div className="row mb-3">
        <div className="col-md-6">
          <label className="form-label">Naam:</label>
          <p className="form-control-plaintext">{userData.name}</p>
        </div>
        <div className="col-md-6">
          <label className="form-label">Email:</label>
          <p className="form-control-plaintext">{userData.email}</p>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-md-6">
          <label className="form-label">Rol:</label>
          <p className="form-control-plaintext">{userData.role}</p>
        </div>
        <div className="col-md-6">
          <label className="form-label">Status:</label>
          <p className="form-control-plaintext">{userData.status}</p>
        </div>
      </div>

      {loggedRole === 'super_admin' && !is_single_user && (
        <div className="row mb-3">
          <div className="col-md-12">
            <label className="form-label">Locaties:</label>
            <p className="form-control-plaintext">
              {getLocationNames(userData.location_ids)}
            </p>
          </div>
        </div>
      )}

      {loggedRole === 'locatie_admin' && (
        <div className="row mb-3">
          <div className="col-md-12">
            <label className="form-label">Locatie:</label>
            <p className="form-control-plaintext">
              {getLocationNames(userData.location_ids)}
            </p>
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-md-6">
          <button
            type="button"
            className="btn btn-secondary w-100 rounded-0"
            onClick={handleBack}
          >
            Terug
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewUser;